module.exports = __webpack_public_path__ + "static/cuatroruedaas-8a790786729c2683abf037c528bf770a.png";